import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const mapApplicationDetailToRecommendedProperty = (
    propertyDetail: IPropertyDetailApplication,
    offerDetail: IOfferDetailApplication
): IRecommendedProperty => ({
    id: propertyDetail.id,
    area: propertyDetail.area,
    floor: propertyDetail.floor,
    is_luxury: propertyDetail.is_luxury,
    rooms: propertyDetail.rooms,
    number: propertyDetail.number,
    distance: 0,
    price: propertyDetail.price,
    offer: {
        id: offerDetail.id,
        geo_point: {
            type: "Point",
            coordinates: offerDetail.geo_point.coordinates
        },
        construction_date_range: offerDetail.construction_date_range,
        name: offerDetail.name,
        type: offerDetail.type,
        address: offerDetail.address,
        configuration: {
            is_autoresponder_enabled: offerDetail.configuration.is_autoresponder_enabled,
            privacy_policy_url: offerDetail.configuration.privacy_policy_url,
            personal_data_processor_url: offerDetail.configuration.personal_data_processor_url,
            personal_data_processor_name: offerDetail.configuration.personal_data_processor_name,
            hide_properties_prices_for_anonymous_users: false,
            revealed_prices_enabled: offerDetail.configuration.revealed_prices,
            price_visibility: offerDetail.configuration.price_visibility
        },
        vendor: {
            configuration: {
                price_visibility: offerDetail.configuration.price_visibility
            },
            id: offerDetail.vendor,
            name: "",
            logo_url: null
        },
        region: {
            country: offerDetail.region.country,
            full_name: offerDetail.region.full_name,
            full_name_reverted: offerDetail.region.full_name,
            name: offerDetail.region.full_name,
            id: offerDetail.region.id,
            type: offerDetail.region.type,
            is_duplicate: false,
            name_declension_where: "",
            name_declension_what: "",
            parent: {
                id: offerDetail.region.parent?.id ?? 0,
                name: "",
                slug: ""
            }
        },
        distance_from_the_airport: null,
        distance_from_the_beach: null
    },
    region: {
        country: offerDetail.region.country,
        id: offerDetail.region.id,
        type: offerDetail.region.type,
        parent: offerDetail.region.parent
    }
});
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const mapApplicationDetailToRecommendedProperty = (
    propertyDetail: IPropertyDetailApplication,
    offerDetail: IOfferDetailApplication
): IRecommendedProperty => ({
    id: propertyDetail.id,
    area: propertyDetail.area,
    floor: propertyDetail.floor,
    is_luxury: propertyDetail.is_luxury,
    rooms: propertyDetail.rooms,
    number: propertyDetail.number,
    distance: 0,
    price: propertyDetail.price,
    offer: {
        id: offerDetail.id,
        geo_point: {
            type: "Point",
            coordinates: offerDetail.geo_point.coordinates
        },
        construction_date_range: offerDetail.construction_date_range,
        name: offerDetail.name,
        type: offerDetail.type,
        address: offerDetail.address,
        configuration: {
            is_autoresponder_enabled: offerDetail.configuration.is_autoresponder_enabled,
            privacy_policy_url: offerDetail.configuration.privacy_policy_url,
            personal_data_processor_url: offerDetail.configuration.personal_data_processor_url,
            personal_data_processor_name: offerDetail.configuration.personal_data_processor_name,
            hide_properties_prices_for_anonymous_users: false,
            revealed_prices_enabled: offerDetail.configuration.revealed_prices,
            price_visibility: offerDetail.configuration.price_visibility
        },
        vendor: {
            configuration: {
                price_visibility: offerDetail.configuration.price_visibility
            },
            id: offerDetail.vendor,
            name: "",
            logo_url: null
        },
        region: {
            country: offerDetail.region.country,
            full_name: offerDetail.region.full_name,
            full_name_reverted: offerDetail.region.full_name,
            name: offerDetail.region.full_name,
            id: offerDetail.region.id,
            type: offerDetail.region.type,
            is_duplicate: false,
            name_declension_where: "",
            name_declension_what: "",
            parent: {
                id: offerDetail.region.parent?.id ?? 0,
                name: "",
                slug: ""
            }
        },
        distance_from_the_airport: null,
        distance_from_the_beach: null
    },
    region: {
        country: offerDetail.region.country,
        id: offerDetail.region.id,
        type: offerDetail.region.type,
        parent: offerDetail.region.parent
    }
});
